// // // import {
// // //   Box,
// // //   Button,
// // //   Chip,
// // //   CircularProgress,
// // //   Grid,
// // //   InputAdornment,
// // //   List,
// // //   ListItem,
// // //   Paper,
// // //   TextField,
// // //   ToggleButton,
// // //   ToggleButtonGroup,
// // //   Typography,
// // //   useMediaQuery,
// // //   useTheme
// // // } from '@mui/material';
// // // import { useAppSelector } from 'app/hooks';
// // // import { useEffect, useState } from 'react';
// // // import { FaArrowUp, FaClock, FaCoins, FaSearch, FaShoppingCart, FaUser } from 'react-icons/fa';
// // // import { useDispatch } from 'react-redux';
// // // import { useNavigate } from 'react-router-dom';
// // // import { getBuySellingUnitsDashboard } from 'slices/fundManagementInvestment/simulationDashboardSlice';

// // // // Exact palette from MainDashboard
// // // const palette = {
// // //   cardBg: 'rgba(36,37,44,0.97)',
// // //   border: '1px solid rgba(255,255,255,0.05)',
// // //   cardShadow: '0 8px 40px rgba(0,0,0,0.8)',
// // //   text: '#EEF1F6',
// // //   subText: '#A6ABBF'
// // // };

// // // const formatCurrency = (amount: number | string): string =>
// // //   new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(Number(amount));

// // // interface BuySellingUnitsSectionProps {
// // //   onUnitSelect?: (unitType: 'income' | 'growth') => void;
// // // }

// // // export default function BuySellingUnitsSection({ onUnitSelect }: BuySellingUnitsSectionProps) {
// // //   const dispatch = useDispatch();
// // //   const navigate = useNavigate();
// // //   const theme = useTheme();
// // //   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// // //   const isTablet = useMediaQuery(theme.breakpoints.down('md'));

// // //   const selectedProjectId = useAppSelector((s) => s.homeTilesServices.selectedProjectId);
// // //   const buySellingData = useAppSelector((s) => s.simulationDashboard.buySellingUnitsDashboardData);
// // //   const loading = useAppSelector((s) => s.simulationDashboard.buySellingUnitsDashboardLoading);

// // //   const [search, setSearch] = useState('');
// // //   const [unitType, setUnitType] = useState<'incomeUnits' | 'growthUnits'>('growthUnits');

// // //   useEffect(() => {
// // //     if (selectedProjectId) {
// // //       dispatch(
// // //         getBuySellingUnitsDashboard({
// // //           groupId: selectedProjectId,
// // //           serviceId: 'fundManagementInvestment',
// // //           unitType
// // //         }) as any
// // //       );
// // //     }
// // //   }, [selectedProjectId, unitType, dispatch]);

// // //   const handleUnitTypeChange = (_: any, newType: 'incomeUnits' | 'growthUnits' | null) => {
// // //     if (newType) setUnitType(newType);
// // //   };

// // //   const handleBuy = (request: any) => {
// // //     console.log('handleBuy request:', request);

// // //     navigate('/fundManagementInvestment/purchase-units', {
// // //       state: {
// // //         fromMarketplace: true,
// // //         sellingRequest: {
// // //           requestId: request.requestId,
// // //           sellerName: request.sellerName,
// // //           sellerEmailId: request.sellerEmailId,
// // //           sellUnits: parseFloat(request.sellUnits),
// // //           unitPrice: parseFloat(request.unitPrice),
// // //           operationCharge: parseFloat(request.operationCharge),
// // //           sellerWillGetAmount: parseFloat(request.sellerWillGetAmount),
// // //           totalSellAmount: parseFloat(request.totalSellAmount),
// // //           subscriptionType: unitType,
// // //           status: request.status,
// // //           date_str: request.date_str
// // //         }
// // //       }
// // //     });
// // //   };

// // //   const allRequests = Array.isArray(buySellingData)
// // //     ? buySellingData.flatMap((d: any) => d.buySellingUnitRequests || [])
// // //     : buySellingData?.buySellingUnitRequests || [];

// // //   const filtered = allRequests.filter(
// // //     (r: any) =>
// // //       !search ||
// // //       r.sellerName.toLowerCase().includes(search.toLowerCase()) ||
// // //       r.sellerEmailId.toLowerCase().includes(search.toLowerCase())
// // //   );

// // //   const getStatusConfig = (status: string) => {
// // //     switch (status.toLowerCase()) {
// // //       case 'pending':
// // //         return { color: '#fbbf24', bg: 'rgba(251, 146, 60, 0.15)', label: 'Pending' };
// // //       case 'completed':
// // //         return { color: '#34d399', bg: 'rgba(52, 211, 153, 0.15)', label: 'Completed' };
// // //       case 'accepted':
// // //         return { color: '#60a5fa', bg: 'rgba(96, 165, 250, 0.15)', label: 'Accepted' };
// // //       case 'rejected':
// // //         return { color: '#f87171', bg: 'rgba(248, 113, 113, 0.15)', label: 'Rejected' };
// // //       default:
// // //         return { color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.12)', label: status };
// // //     }
// // //   };

// // //   return (
// // //     <Paper
// // //       elevation={0}
// // //       sx={{
// // //         background: palette.cardBg,
// // //         border: palette.border,
// // //         boxShadow: palette.cardShadow,
// // //         borderRadius: 2,
// // //         overflow: 'hidden'
// // //       }}
// // //     >
// // //       {/* Header */}
// // //       <Box
// // //         sx={{
// // //           p: { xs: 1.5, sm: 2 },
// // //           borderBottom: palette.border,
// // //           background: 'rgba(59, 130, 246, 0.05)'
// // //         }}
// // //       >
// // //         <Typography
// // //           variant="h6"
// // //           sx={{
// // //             fontWeight: 600,
// // //             color: palette.text,
// // //             fontSize: { xs: '0.85rem', sm: '1rem' }
// // //           }}
// // //         >
// // //           Unit Marketplace
// // //         </Typography>
// // //       </Box>

// // //       {/* Controls - Toggle Buttons */}
// // //       <Box sx={{ p: { xs: 1.5, sm: 2 }, borderBottom: palette.border }}>
// // //         <ToggleButtonGroup
// // //           value={unitType}
// // //           exclusive
// // //           onChange={handleUnitTypeChange}
// // //           fullWidth={isMobile}
// // //           sx={{
// // //             height: { xs: 44, sm: 56 },
// // //             bgcolor: 'rgba(255,255,255,0.04)',
// // //             borderRadius: 2.5,
// // //             p: { xs: 0.5, sm: 0.75 },
// // //             color: 'white',
// // //             border: '1px solid rgba(255,255,255,0.06)',
// // //             '& .MuiToggleButton-root': {
// // //               border: 'none',
// // //               borderRadius: 2,
// // //               textTransform: 'none',
// // //               fontWeight: 600,
// // //               fontSize: { xs: '0.75rem', sm: '0.95rem' },
// // //               py: { xs: 1.2, sm: 1.8 },
// // //               color: palette.subText,
// // //               transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
// // //               position: 'relative',
// // //               zIndex: 1,

// // //               '&:hover': {
// // //                 bgcolor: 'rgba(255,255,255,0.08)',
// // //                 color: '#e2e8f0'
// // //               },

// // //               '&.Mui-selected': {
// // //                 color: '#FFFFFF !important',
// // //                 fontWeight: 700,
// // //                 zIndex: 2,
// // //                 boxShadow: `
// // //                   0 0 0 2px rgba(255,255,255,0.15),
// // //                   0 0 20px rgba(59, 130, 246, 0.3),
// // //                   inset 0 2px 8px rgba(255,255,255,0.12)
// // //                 `,
// // //                 transform: 'translateY(-2px)',

// // //                 '&:hover': {
// // //                   boxShadow: `
// // //                     0 0 0 2px rgba(255,255,255,0.2),
// // //                     0 0 25px rgba(59, 130, 246, 0.4),
// // //                     inset 0 2px 8px rgba(255,255,255,0.15)
// // //                   `
// // //                 }
// // //               }
// // //             }
// // //           }}
// // //         >
// // //           <ToggleButton
// // //             value="incomeUnits"
// // //             sx={{
// // //               bgcolor:
// // //                 unitType === 'incomeUnits'
// // //                   ? 'linear-gradient(135deg, #3b82f6 0%, #0ea5e9 100%)'
// // //                   : 'transparent',

// // //               '&.Mui-selected': {
// // //                 bgcolor: 'linear-gradient(135deg, #3b82f6 0%, #0ea5e9 100%)',
// // //                 '&:hover': {
// // //                   bgcolor: 'linear-gradient(135deg, #2563eb 0%, #0284c7 100%)'
// // //                 }
// // //               }
// // //             }}
// // //           >
// // //             <FaCoins style={{ marginRight: isMobile ? 6 : 10 }} size={isMobile ? 12 : 14} />
// // //             Income Units
// // //           </ToggleButton>

// // //           <ToggleButton
// // //             value="growthUnits"
// // //             sx={{
// // //               bgcolor:
// // //                 unitType === 'growthUnits'
// // //                   ? 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)'
// // //                   : 'transparent',

// // //               '&.Mui-selected': {
// // //                 bgcolor: 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)',
// // //                 '&:hover': {
// // //                   bgcolor: 'linear-gradient(135deg, #ea580c 0%, #f97316 100%)'
// // //                 }
// // //               }
// // //             }}
// // //           >
// // //             <FaArrowUp style={{ marginRight: isMobile ? 6 : 10 }} size={isMobile ? 12 : 14} />
// // //             Growth Units
// // //           </ToggleButton>
// // //         </ToggleButtonGroup>
// // //       </Box>

// // //       {/* Search */}
// // //       <Box
// // //         sx={{
// // //           p: { xs: 1.5, sm: 2 },
// // //           borderBottom: palette.border,
// // //           bgcolor: '#0f1115'
// // //         }}
// // //       >
// // //         <TextField
// // //           fullWidth
// // //           size="small"
// // //           placeholder="Search seller..."
// // //           value={search}
// // //           onChange={(e) => setSearch(e.target.value)}
// // //           InputProps={{
// // //             startAdornment: (
// // //               <InputAdornment position="start">
// // //                 <FaSearch color="#60a5fa" size={isMobile ? 12 : 14} />
// // //               </InputAdornment>
// // //             )
// // //           }}
// // //           sx={{
// // //             '& .MuiOutlinedInput-root': {
// // //               borderRadius: 1.5,
// // //               backgroundColor: '#1a1c20',
// // //               fontSize: { xs: '0.75rem', sm: '0.85rem' },
// // //               color: '#e5e7eb',

// // //               '& fieldset': {
// // //                 borderColor: 'rgba(255,255,255,0.15)'
// // //               },
// // //               '&:hover fieldset': {
// // //                 borderColor: 'rgba(96,165,250,0.6)'
// // //               },
// // //               '&.Mui-focused fieldset': {
// // //                 borderColor: '#3b82f6'
// // //               },

// // //               // 🔥 Ensures inner typing area also dark
// // //               '& input': {
// // //                 backgroundColor: '#1a1c20',
// // //                 color: '#e5e7eb'
// // //               }
// // //             },

// // //             // 🔥 Dark placeholder
// // //             '& .MuiInputBase-input::placeholder': {
// // //               color: 'rgba(255,255,255,0.4)',
// // //               opacity: 1
// // //             }
// // //           }}
// // //         />
// // //       </Box>

// // //       {/* List */}
// // //       <Box
// // //         sx={{ maxHeight: { xs: '350px', sm: '400px' }, overflowY: 'auto', p: { xs: 1.5, sm: 2 } }}
// // //       >
// // //         {loading ? (
// // //           <Box sx={{ textAlign: 'center', py: 4 }}>
// // //             <CircularProgress size={isMobile ? 28 : 36} sx={{ color: '#3b82f6' }} />
// // //             <Typography
// // //               sx={{ mt: 2, color: palette.subText, fontSize: { xs: '0.75rem', sm: '0.85rem' } }}
// // //             >
// // //               Loading...
// // //             </Typography>
// // //           </Box>
// // //         ) : filtered.length === 0 ? (
// // //           <Box sx={{ textAlign: 'center', py: 4 }}>
// // //             <FaSearch size={isMobile ? 28 : 36} color="rgba(255,255,255,0.1)" />
// // //             <Typography
// // //               sx={{ mt: 2, color: palette.text, fontSize: { xs: '0.85rem', sm: '0.95rem' } }}
// // //             >
// // //               No active offers
// // //             </Typography>
// // //             <Typography
// // //               sx={{ color: palette.subText, mt: 0.5, fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
// // //             >
// // //               Check back later
// // //             </Typography>
// // //           </Box>
// // //         ) : (
// // //           <List disablePadding>
// // //             {filtered.map((request: any) => {
// // //               const status = getStatusConfig(request.status);
// // //               const canBuy = request.status === 'pending' && !request.isBuyRequestSomeOne;

// // //               return (
// // //                 <ListItem
// // //                   key={request.requestId}
// // //                   sx={{
// // //                     mb: { xs: 1, sm: 1.5 },
// // //                     borderRadius: 1.5,
// // //                     background: 'rgba(255,255,255,0.02)',
// // //                     border: '1px solid rgba(255,255,255,0.05)',
// // //                     flexDirection: 'column',
// // //                     alignItems: 'flex-start',
// // //                     p: { xs: 1, sm: 1.5 },
// // //                     transition: 'all 0.3s ease',
// // //                     '&:hover': {
// // //                       borderColor: '#3b82f6',
// // //                       boxShadow: '0 4px 20px rgba(59, 130, 246, 0.2)',
// // //                       transform: 'translateY(-2px)'
// // //                     }
// // //                   }}
// // //                 >
// // //                   {/* Seller Info */}
// // //                   <Box
// // //                     display="flex"
// // //                     alignItems="center"
// // //                     gap={{ xs: 1, sm: 1.5 }}
// // //                     width="100%"
// // //                     mb={{ xs: 1, sm: 1.5 }}
// // //                   >
// // //                     <Box
// // //                       sx={{
// // //                         width: { xs: 32, sm: 36 },
// // //                         height: { xs: 32, sm: 36 },
// // //                         borderRadius: 1,
// // //                         background:
// // //                           unitType === 'incomeUnits'
// // //                             ? 'linear-gradient(135deg, #3b82f6, #0ea5e9)'
// // //                             : 'linear-gradient(135deg, #f97316, #fb923c)',
// // //                         display: 'flex',
// // //                         alignItems: 'center',
// // //                         justifyContent: 'center',
// // //                         color: '#fff'
// // //                       }}
// // //                     >
// // //                       <FaUser size={isMobile ? 14 : 16} />
// // //                     </Box>
// // //                     <Box flex={1} minWidth={0}>
// // //                       <Typography
// // //                         sx={{
// // //                           fontWeight: 600,
// // //                           color: palette.text,
// // //                           fontSize: { xs: '0.75rem', sm: '0.85rem' },
// // //                           overflow: 'hidden',
// // //                           textOverflow: 'ellipsis',
// // //                           whiteSpace: 'nowrap'
// // //                         }}
// // //                       >
// // //                         {request.sellerName}
// // //                       </Typography>
// // //                       <Typography
// // //                         sx={{
// // //                           color: palette.subText,
// // //                           fontSize: { xs: '0.65rem', sm: '0.7rem' },
// // //                           overflow: 'hidden',
// // //                           textOverflow: 'ellipsis',
// // //                           whiteSpace: 'nowrap'
// // //                         }}
// // //                       >
// // //                         {request.sellerEmailId}
// // //                       </Typography>
// // //                     </Box>
// // //                     <Chip
// // //                       label={status.label}
// // //                       size="small"
// // //                       sx={{
// // //                         bgcolor: status.bg,
// // //                         color: status.color,
// // //                         fontWeight: 600,
// // //                         fontSize: { xs: '0.65rem', sm: '0.7rem' },
// // //                         height: { xs: 20, sm: 22 }
// // //                       }}
// // //                     />
// // //                   </Box>

// // //                   {/* Stats Row */}
// // //                   <Grid container spacing={{ xs: 1, sm: 1.5 }} mb={{ xs: 1, sm: 1.5 }}>
// // //                     <Grid item xs={6} sm={3}>
// // //                       <Typography
// // //                         sx={{ color: palette.subText, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}
// // //                       >
// // //                         Units
// // //                       </Typography>
// // //                       <Typography
// // //                         sx={{
// // //                           fontWeight: 700,
// // //                           color: palette.text,
// // //                           fontSize: { xs: '0.8rem', sm: '0.9rem' }
// // //                         }}
// // //                       >
// // //                         {parseFloat(request.sellUnits).toLocaleString()}
// // //                       </Typography>
// // //                     </Grid>
// // //                     <Grid item xs={6} sm={3}>
// // //                       <Typography
// // //                         sx={{ color: palette.subText, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}
// // //                       >
// // //                         Price
// // //                       </Typography>
// // //                       <Typography
// // //                         sx={{
// // //                           fontWeight: 700,
// // //                           color: '#10b981',
// // //                           fontSize: { xs: '0.8rem', sm: '0.9rem' }
// // //                         }}
// // //                       >
// // //                         {formatCurrency(request.unitPrice)}
// // //                       </Typography>
// // //                     </Grid>
// // //                     <Grid item xs={6} sm={3}>
// // //                       <Typography
// // //                         sx={{ color: palette.subText, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}
// // //                       >
// // //                         Op. Charge
// // //                       </Typography>
// // //                       <Typography
// // //                         sx={{
// // //                           fontWeight: 700,
// // //                           color: '#10b981',
// // //                           fontSize: { xs: '0.8rem', sm: '0.9rem' }
// // //                         }}
// // //                       >
// // //                         {request.operationCharge}%
// // //                       </Typography>
// // //                     </Grid>
// // //                     <Grid item xs={6} sm={3}>
// // //                       <Typography
// // //                         sx={{ color: palette.subText, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}
// // //                       >
// // //                         Total
// // //                       </Typography>
// // //                       <Typography
// // //                         sx={{
// // //                           fontWeight: 700,
// // //                           color: '#34d399',
// // //                           fontSize: { xs: '0.8rem', sm: '0.9rem' }
// // //                         }}
// // //                       >
// // //                         {formatCurrency(request.sellUnits * request.unitPrice)}
// // //                       </Typography>
// // //                     </Grid>
// // //                   </Grid>

// // //                   {/* Action Button */}
// // //                   <Box width="100%">
// // //                     {canBuy ? (
// // //                       <Button
// // //                         variant="contained"
// // //                         size="small"
// // //                         fullWidth
// // //                         startIcon={<FaShoppingCart size={isMobile ? 10 : 12} />}
// // //                         onClick={() => handleBuy(request)}
// // //                         sx={{
// // //                           bgcolor: 'linear-gradient(135deg, #10b981, #34d399)',
// // //                           color: 'white',
// // //                           fontWeight: 700,
// // //                           textTransform: 'none',
// // //                           borderRadius: 1.5,
// // //                           fontSize: { xs: '0.7rem', sm: '0.8rem' },
// // //                           py: { xs: 0.75, sm: 1 },
// // //                           boxShadow: '0 4px 12px rgba(52,211,153,0.3)',
// // //                           '&:hover': {
// // //                             bgcolor: '#059669',
// // //                             boxShadow: '0 6px 16px rgba(52,211,153,0.4)'
// // //                           }
// // //                         }}
// // //                       >
// // //                         Buy Now
// // //                       </Button>
// // //                     ) : (
// // //                       <Box
// // //                         display="flex"
// // //                         alignItems="center"
// // //                         justifyContent="center"
// // //                         gap={1}
// // //                         color="#fbbf24"
// // //                         width="100%"
// // //                         py={{ xs: 0.75, sm: 1 }}
// // //                       >
// // //                         <FaClock size={isMobile ? 10 : 12} />
// // //                         <Typography
// // //                           sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' }, fontWeight: 500 }}
// // //                         >
// // //                           In Process
// // //                         </Typography>
// // //                       </Box>
// // //                     )}
// // //                   </Box>
// // //                 </ListItem>
// // //               );
// // //             })}
// // //           </List>
// // //         )}
// // //       </Box>
// // //     </Paper>
// // //   );
// // // }

// // import {
// //   Box,
// //   Button,
// //   Chip,
// //   CircularProgress,
// //   Grid,
// //   InputAdornment,
// //   List,
// //   ListItem,
// //   Paper,
// //   TextField,
// //   ToggleButton,
// //   ToggleButtonGroup,
// //   Typography,
// //   useMediaQuery,
// //   useTheme
// // } from '@mui/material';
// // import { useAppSelector } from 'app/hooks';
// // import { useEffect, useState } from 'react';
// // import { FaArrowUp, FaClock, FaCoins, FaSearch, FaShoppingCart, FaUser } from 'react-icons/fa';
// // import { useDispatch } from 'react-redux';
// // import { useNavigate } from 'react-router-dom';
// // import { getBuySellingUnitsDashboard } from 'slices/fundManagementInvestment/simulationDashboardSlice';

// // // Exact palette from MainDashboard
// // const palette = {
// //   cardBg: 'rgba(36,37,44,0.97)',
// //   border: '1px solid rgba(255,255,255,0.05)',
// //   cardShadow: '0 8px 40px rgba(0,0,0,0.8)',
// //   text: '#EEF1F6',
// //   subText: '#A6ABBF'
// // };

// // const formatCurrency = (amount: number | string): string =>
// //   new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(Number(amount));

// // interface BuySellingUnitsSectionProps {
// //   onUnitSelect?: (unitType: 'income' | 'growth') => void;
// // }

// // export default function BuySellingUnitsSection({ onUnitSelect }: BuySellingUnitsSectionProps) {
// //   const dispatch = useDispatch();
// //   const navigate = useNavigate();
// //   const theme = useTheme();
// //   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// //   const isTablet = useMediaQuery(theme.breakpoints.down('md'));

// //   const selectedProjectId = useAppSelector((s) => s.homeTilesServices.selectedProjectId);
// //   const buySellingData = useAppSelector((s) => s.simulationDashboard.buySellingUnitsDashboardData);
// //   const loading = useAppSelector((s) => s.simulationDashboard.buySellingUnitsDashboardLoading);

// //   const [search, setSearch] = useState('');
// //   const [unitType, setUnitType] = useState<'incomeUnits' | 'growthUnits'>('growthUnits');

// //   useEffect(() => {
// //     if (selectedProjectId) {
// //       dispatch(
// //         getBuySellingUnitsDashboard({
// //           groupId: selectedProjectId,
// //           serviceId: 'fundManagementInvestment',
// //           unitType
// //         }) as any
// //       );
// //     }
// //   }, [selectedProjectId, unitType, dispatch]);

// //   const handleUnitTypeChange = (_: any, newType: 'incomeUnits' | 'growthUnits' | null) => {
// //     if (newType) setUnitType(newType);
// //   };

// //   const handleBuy = (request: any) => {
// //     console.log('handleBuy request:', request);

// //     navigate('/fundManagementInvestment/purchase-units', {
// //       state: {
// //         fromMarketplace: true,
// //         sellingRequest: {
// //           requestId: request.requestId,
// //           sellerName: request.sellerName,
// //           sellerEmailId: request.sellerEmailId,
// //           sellUnits: parseFloat(request.sellUnits),
// //           unitPrice: parseFloat(request.unitPrice),
// //           operationCharge: parseFloat(request.operationCharge),
// //           sellerWillGetAmount: parseFloat(request.sellerWillGetAmount),
// //           totalSellAmount: parseFloat(request.totalSellAmount),
// //           subscriptionType: unitType,
// //           status: request.status,
// //           date_str: request.date_str
// //         }
// //       }
// //     });
// //   };

// //   const allRequests = Array.isArray(buySellingData)
// //     ? buySellingData.flatMap((d: any) => d.buySellingUnitRequests || [])
// //     : buySellingData?.buySellingUnitRequests || [];

// //   const filtered = allRequests.filter(
// //     (r: any) =>
// //       !search ||
// //       r.sellerName.toLowerCase().includes(search.toLowerCase()) ||
// //       r.sellerEmailId.toLowerCase().includes(search.toLowerCase())
// //   );

// //   const getStatusConfig = (status: string) => {
// //     switch (status.toLowerCase()) {
// //       case 'pending':
// //         return { color: '#fbbf24', bg: 'rgba(251, 146, 60, 0.15)', label: 'Pending' };
// //       case 'completed':
// //         return { color: '#34d399', bg: 'rgba(52, 211, 153, 0.15)', label: 'Completed' };
// //       case 'accepted':
// //         return { color: '#60a5fa', bg: 'rgba(96, 165, 250, 0.15)', label: 'Accepted' };
// //       case 'rejected':
// //         return { color: '#f87171', bg: 'rgba(248, 113, 113, 0.15)', label: 'Rejected' };
// //       default:
// //         return { color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.12)', label: status };
// //     }
// //   };

// //   return (
// //     <Paper
// //       elevation={0}
// //       sx={{
// //         background: palette.cardBg,
// //         border: palette.border,
// //         boxShadow: palette.cardShadow,
// //         borderRadius: 2,
// //         overflow: 'hidden'
// //       }}
// //     >
// //       {/* Header */}
// //       <Box
// //         sx={{
// //           p: { xs: 1.5, sm: 2 },
// //           borderBottom: palette.border,
// //           background: 'rgba(59, 130, 246, 0.05)'
// //         }}
// //       >
// //         <Typography
// //           variant="h6"
// //           sx={{
// //             fontWeight: 600,
// //             color: palette.text,
// //             fontSize: { xs: '0.85rem', sm: '1rem' }
// //           }}
// //         >
// //           Unit Marketplace
// //         </Typography>
// //       </Box>

// //       {/* Controls - Toggle Buttons */}
// //       <Box sx={{ p: { xs: 1.5, sm: 2 }, borderBottom: palette.border }}>
// //         <ToggleButtonGroup
// //           value={unitType}
// //           exclusive
// //           onChange={handleUnitTypeChange}
// //           fullWidth={isMobile}
// //           sx={{
// //             height: { xs: 44, sm: 56 },
// //             bgcolor: 'rgba(255,255,255,0.04)',
// //             borderRadius: 2.5,
// //             p: { xs: 0.5, sm: 0.75 },
// //             color: 'white',
// //             border: '1px solid rgba(255,255,255,0.06)',
// //             '& .MuiToggleButton-root': {
// //               border: 'none',
// //               borderRadius: 2,
// //               textTransform: 'none',
// //               fontWeight: 600,
// //               fontSize: { xs: '0.75rem', sm: '0.95rem' },
// //               py: { xs: 1.2, sm: 1.8 },
// //               color: palette.subText,
// //               transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
// //               position: 'relative',
// //               zIndex: 1,

// //               '&:hover': {
// //                 bgcolor: 'rgba(255,255,255,0.08)',
// //                 color: '#e2e8f0'
// //               },

// //               '&.Mui-selected': {
// //                 color: '#FFFFFF !important',
// //                 fontWeight: 700,
// //                 zIndex: 2,
// //                 boxShadow: `
// //                   0 0 0 2px rgba(255,255,255,0.15),
// //                   0 0 20px rgba(59, 130, 246, 0.3),
// //                   inset 0 2px 8px rgba(255,255,255,0.12)
// //                 `,
// //                 transform: 'translateY(-2px)',

// //                 '&:hover': {
// //                   boxShadow: `
// //                     0 0 0 2px rgba(255,255,255,0.2),
// //                     0 0 25px rgba(59, 130, 246, 0.4),
// //                     inset 0 2px 8px rgba(255,255,255,0.15)
// //                   `
// //                 }
// //               }
// //             }
// //           }}
// //         >
// //           <ToggleButton
// //             value="incomeUnits"
// //             sx={{
// //               bgcolor:
// //                 unitType === 'incomeUnits'
// //                   ? 'linear-gradient(135deg, #3b82f6 0%, #0ea5e9 100%)'
// //                   : 'transparent',

// //               '&.Mui-selected': {
// //                 bgcolor: 'linear-gradient(135deg, #3b82f6 0%, #0ea5e9 100%)',
// //                 '&:hover': {
// //                   bgcolor: 'linear-gradient(135deg, #2563eb 0%, #0284c7 100%)'
// //                 }
// //               }
// //             }}
// //           >
// //             <FaCoins style={{ marginRight: isMobile ? 6 : 10 }} size={isMobile ? 12 : 14} />
// //             Income Units
// //           </ToggleButton>

// //           <ToggleButton
// //             value="growthUnits"
// //             sx={{
// //               bgcolor:
// //                 unitType === 'growthUnits'
// //                   ? 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)'
// //                   : 'transparent',

// //               '&.Mui-selected': {
// //                 bgcolor: 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)',
// //                 '&:hover': {
// //                   bgcolor: 'linear-gradient(135deg, #ea580c 0%, #f97316 100%)'
// //                 }
// //               }
// //             }}
// //           >
// //             <FaArrowUp style={{ marginRight: isMobile ? 6 : 10 }} size={isMobile ? 12 : 14} />
// //             Growth Units
// //           </ToggleButton>
// //         </ToggleButtonGroup>
// //       </Box>

// //       {/* Search */}
// //       <Box
// //         sx={{
// //           p: { xs: 1.5, sm: 2 },
// //           borderBottom: palette.border,
// //           bgcolor: '#0f1115'
// //         }}
// //       >
// //         <TextField
// //           fullWidth
// //           size="small"
// //           placeholder="Search seller..."
// //           value={search}
// //           onChange={(e) => setSearch(e.target.value)}
// //           InputProps={{
// //             startAdornment: (
// //               <InputAdornment position="start">
// //                 <FaSearch color="#60a5fa" size={isMobile ? 12 : 14} />
// //               </InputAdornment>
// //             )
// //           }}
// //           sx={{
// //             '& .MuiOutlinedInput-root': {
// //               borderRadius: 1.5,
// //               backgroundColor: '#1a1c20',
// //               fontSize: { xs: '0.75rem', sm: '0.85rem' },
// //               color: '#e5e7eb',

// //               '& fieldset': {
// //                 borderColor: 'rgba(255,255,255,0.15)'
// //               },
// //               '&:hover fieldset': {
// //                 borderColor: 'rgba(96,165,250,0.6)'
// //               },
// //               '&.Mui-focused fieldset': {
// //                 borderColor: '#3b82f6'
// //               },

// //               // 🔥 Ensures inner typing area also dark
// //               '& input': {
// //                 backgroundColor: '#1a1c20',
// //                 color: '#e5e7eb'
// //               }
// //             },

// //             // 🔥 Dark placeholder
// //             '& .MuiInputBase-input::placeholder': {
// //               color: 'rgba(255,255,255,0.4)',
// //               opacity: 1
// //             }
// //           }}
// //         />
// //       </Box>

// //       {/* List */}
// //       <Box
// //         sx={{ maxHeight: { xs: '350px', sm: '400px' }, overflowY: 'auto', p: { xs: 1.5, sm: 2 } }}
// //       >
// //         {loading ? (
// //           <Box sx={{ textAlign: 'center', py: 4 }}>
// //             <CircularProgress size={isMobile ? 28 : 36} sx={{ color: '#3b82f6' }} />
// //             <Typography
// //               sx={{ mt: 2, color: palette.subText, fontSize: { xs: '0.75rem', sm: '0.85rem' } }}
// //             >
// //               Loading...
// //             </Typography>
// //           </Box>
// //         ) : filtered.length === 0 ? (
// //           <Box sx={{ textAlign: 'center', py: 4 }}>
// //             <FaSearch size={isMobile ? 28 : 36} color="rgba(255,255,255,0.1)" />
// //             <Typography
// //               sx={{ mt: 2, color: palette.text, fontSize: { xs: '0.85rem', sm: '0.95rem' } }}
// //             >
// //               No active offers
// //             </Typography>
// //             <Typography
// //               sx={{ color: palette.subText, mt: 0.5, fontSize: { xs: '0.7rem', sm: '0.8rem' } }}
// //             >
// //               Check back later
// //             </Typography>
// //           </Box>
// //         ) : (
// //           <List disablePadding>
// //             {filtered.map((request: any) => {
// //               const status = getStatusConfig(request.status);
// //               const canBuy = request.status === 'pending' && !request.isBuyRequestSomeOne;

// //               return (
// //                 <ListItem
// //                   key={request.requestId}
// //                   sx={{
// //                     mb: { xs: 1, sm: 1.5 },
// //                     borderRadius: 1.5,
// //                     background: 'rgba(255,255,255,0.02)',
// //                     border: '1px solid rgba(255,255,255,0.05)',
// //                     flexDirection: 'column',
// //                     alignItems: 'flex-start',
// //                     p: { xs: 1, sm: 1.5 },
// //                     transition: 'all 0.3s ease',
// //                     '&:hover': {
// //                       borderColor: '#3b82f6',
// //                       boxShadow: '0 4px 20px rgba(59, 130, 246, 0.2)',
// //                       transform: 'translateY(-2px)'
// //                     }
// //                   }}
// //                 >
// //                   {/* Seller Info */}
// //                   <Box
// //                     display="flex"
// //                     alignItems="center"
// //                     gap={{ xs: 1, sm: 1.5 }}
// //                     width="100%"
// //                     mb={{ xs: 1, sm: 1.5 }}
// //                   >
// //                     <Box
// //                       sx={{
// //                         width: { xs: 32, sm: 36 },
// //                         height: { xs: 32, sm: 36 },
// //                         borderRadius: 1,
// //                         background:
// //                           unitType === 'incomeUnits'
// //                             ? 'linear-gradient(135deg, #3b82f6, #0ea5e9)'
// //                             : 'linear-gradient(135deg, #f97316, #fb923c)',
// //                         display: 'flex',
// //                         alignItems: 'center',
// //                         justifyContent: 'center',
// //                         color: '#fff'
// //                       }}
// //                     >
// //                       <FaUser size={isMobile ? 14 : 16} />
// //                     </Box>
// //                     <Box flex={1} minWidth={0}>
// //                       <Typography
// //                         sx={{
// //                           fontWeight: 600,
// //                           color: palette.text,
// //                           fontSize: { xs: '0.75rem', sm: '0.85rem' },
// //                           overflow: 'hidden',
// //                           textOverflow: 'ellipsis',
// //                           whiteSpace: 'nowrap'
// //                         }}
// //                       >
// //                         {request.sellerName}
// //                       </Typography>
// //                       <Typography
// //                         sx={{
// //                           color: palette.subText,
// //                           fontSize: { xs: '0.65rem', sm: '0.7rem' },
// //                           overflow: 'hidden',
// //                           textOverflow: 'ellipsis',
// //                           whiteSpace: 'nowrap'
// //                         }}
// //                       >
// //                         {request.sellerEmailId}
// //                       </Typography>
// //                     </Box>
// //                     <Chip
// //                       label={status.label}
// //                       size="small"
// //                       sx={{
// //                         bgcolor: status.bg,
// //                         color: status.color,
// //                         fontWeight: 600,
// //                         fontSize: { xs: '0.65rem', sm: '0.7rem' },
// //                         height: { xs: 20, sm: 22 }
// //                       }}
// //                     />
// //                   </Box>

// //                   {/* Stats Row */}
// //                   <Grid container spacing={{ xs: 1, sm: 1.5 }} mb={{ xs: 1, sm: 1.5 }}>
// //                     <Grid item xs={6} sm={3}>
// //                       <Typography
// //                         sx={{ color: palette.subText, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}
// //                       >
// //                         Units
// //                       </Typography>
// //                       <Typography
// //                         sx={{
// //                           fontWeight: 700,
// //                           color: palette.text,
// //                           fontSize: { xs: '0.8rem', sm: '0.9rem' }
// //                         }}
// //                       >
// //                         {parseFloat(request.sellUnits).toLocaleString()}
// //                       </Typography>
// //                     </Grid>
// //                     <Grid item xs={6} sm={3}>
// //                       <Typography
// //                         sx={{ color: palette.subText, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}
// //                       >
// //                         Price
// //                       </Typography>
// //                       <Typography
// //                         sx={{
// //                           fontWeight: 700,
// //                           color: '#10b981',
// //                           fontSize: { xs: '0.8rem', sm: '0.9rem' }
// //                         }}
// //                       >
// //                         {formatCurrency(request.unitPrice)}
// //                       </Typography>
// //                     </Grid>
// //                     <Grid item xs={6} sm={3}>
// //                       <Typography
// //                         sx={{ color: palette.subText, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}
// //                       >
// //                         Op. Charge
// //                       </Typography>
// //                       <Typography
// //                         sx={{
// //                           fontWeight: 700,
// //                           color: '#10b981',
// //                           fontSize: { xs: '0.8rem', sm: '0.9rem' }
// //                         }}
// //                       >
// //                         {request.operationCharge}%
// //                       </Typography>
// //                     </Grid>
// //                     <Grid item xs={6} sm={3}>
// //                       <Typography
// //                         sx={{ color: palette.subText, fontSize: { xs: '0.65rem', sm: '0.7rem' } }}
// //                       >
// //                         Total
// //                       </Typography>
// //                       <Typography
// //                         sx={{
// //                           fontWeight: 700,
// //                           color: '#34d399',
// //                           fontSize: { xs: '0.8rem', sm: '0.9rem' }
// //                         }}
// //                       >
// //                         {formatCurrency(request.sellUnits * request.unitPrice)}
// //                       </Typography>
// //                     </Grid>
// //                   </Grid>

// //                   {/* Action Button */}
// //                   <Box width="100%">
// //                     {canBuy ? (
// //                       <Button
// //                         variant="contained"
// //                         size="small"
// //                         fullWidth
// //                         startIcon={<FaShoppingCart size={isMobile ? 10 : 12} />}
// //                         onClick={() => handleBuy(request)}
// //                         sx={{
// //                           bgcolor: 'linear-gradient(135deg, #10b981, #34d399)',
// //                           color: 'white',
// //                           fontWeight: 700,
// //                           textTransform: 'none',
// //                           borderRadius: 1.5,
// //                           fontSize: { xs: '0.7rem', sm: '0.8rem' },
// //                           py: { xs: 0.75, sm: 1 },
// //                           boxShadow: '0 4px 12px rgba(52,211,153,0.3)',
// //                           '&:hover': {
// //                             bgcolor: '#059669',
// //                             boxShadow: '0 6px 16px rgba(52,211,153,0.4)'
// //                           }
// //                         }}
// //                       >
// //                         Buy Now
// //                       </Button>
// //                     ) : (
// //                       <Box
// //                         display="flex"
// //                         alignItems="center"
// //                         justifyContent="center"
// //                         gap={1}
// //                         color="#fbbf24"
// //                         width="100%"
// //                         py={{ xs: 0.75, sm: 1 }}
// //                       >
// //                         <FaClock size={isMobile ? 10 : 12} />
// //                         <Typography
// //                           sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' }, fontWeight: 500 }}
// //                         >
// //                           In Process
// //                         </Typography>
// //                       </Box>
// //                     )}
// //                   </Box>
// //                 </ListItem>
// //               );
// //             })}
// //           </List>
// //         )}
// //       </Box>
// //     </Paper>
// //   );
// // }

// import {
//   Box,
//   Button,
//   Chip,
//   CircularProgress,
//   Grid,
//   InputAdornment,
//   List,
//   ListItem,
//   Paper,
//   TextField,
//   ToggleButton,
//   ToggleButtonGroup,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { useAppSelector } from 'app/hooks';
// import { useEffect, useState } from 'react';
// import { FaArrowUp, FaClock, FaCoins, FaSearch, FaShoppingCart, FaUser } from 'react-icons/fa';
// import { useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { getBuySellingUnitsDashboard } from 'slices/fundManagementInvestment/simulationDashboardSlice';

// const palette = {
//   cardBg: 'rgba(36,37,44,0.97)',
//   border: '1px solid rgba(255,255,255,0.05)',
//   cardShadow: '0 8px 40px rgba(0,0,0,0.8)',
//   text: '#EEF1F6',
//   subText: '#A6ABBF'
// };

// const formatCurrency = (amount: number | string): string =>
//   new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(Number(amount));

// interface BuySellingUnitsSectionProps {
//   onUnitSelect?: (unitType: 'income' | 'growth') => void;
// }

// export default function BuySellingUnitsSection({ onUnitSelect }: BuySellingUnitsSectionProps) {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   const selectedProjectId = useAppSelector((s) => s.homeTilesServices.selectedProjectId);
//   const buySellingData = useAppSelector((s) => s.simulationDashboard.buySellingUnitsDashboardData);
//   const loading = useAppSelector((s) => s.simulationDashboard.buySellingUnitsDashboardLoading);

//   const [search, setSearch] = useState('');
//   const [unitType, setUnitType] = useState<'incomeUnits' | 'growthUnits'>('growthUnits');

//   useEffect(() => {
//     if (selectedProjectId) {
//       dispatch(
//         getBuySellingUnitsDashboard({
//           groupId: selectedProjectId,
//           serviceId: 'fundManagementInvestment',
//           unitType
//         }) as any
//       );
//     }
//   }, [selectedProjectId, unitType, dispatch]);

//   const handleUnitTypeChange = (_: any, newType: 'incomeUnits' | 'growthUnits' | null) => {
//     if (newType) {
//       setUnitType(newType);
//       onUnitSelect?.(newType === 'incomeUnits' ? 'income' : 'growth');
//     }
//   };

//   const handleBuy = (request: any) => {
//     navigate('/fundManagementInvestment/purchase-units', {
//       state: {
//         fromMarketplace: true,
//         sellingRequest: {
//           requestId: request.requestId,
//           sellerName: request.sellerName,
//           sellerEmailId: request.sellerEmailId,
//           sellUnits: parseFloat(request.sellUnits),
//           unitPrice: parseFloat(request.unitPrice),
//           operationCharge: parseFloat(request.operationCharge),
//           sellerWillGetAmount: parseFloat(request.sellerWillGetAmount),
//           totalSellAmount: parseFloat(request.totalSellAmount),
//           subscriptionType: unitType,
//           status: request.status,
//           date_str: request.date_str
//         }
//       }
//     });
//   };

//   const allRequests = Array.isArray(buySellingData)
//     ? buySellingData.flatMap((d: any) => d.buySellingUnitRequests || [])
//     : buySellingData?.buySellingUnitRequests || [];

//   const filtered = allRequests.filter(
//     (r: any) =>
//       !search ||
//       r.sellerName?.toLowerCase().includes(search.toLowerCase()) ||
//       r.sellerEmailId?.toLowerCase().includes(search.toLowerCase())
//   );

//   const getStatusConfig = (status: string) => {
//     switch (status.toLowerCase()) {
//       case 'pending':   return { color: '#fbbf24', bg: 'rgba(251, 146, 60, 0.15)', label: 'Pending' };
//       case 'accepted':  return { color: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.15)', label: 'Accepted' };
//       case 'completed': return { color: '#34d399', bg: 'rgba(52, 211, 153, 0.15)', label: 'Completed' };
//       case 'rejected':  return { color: '#f87171', bg: 'rgba(248, 113, 113, 0.15)', label: 'Rejected' };
//       default:          return { color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.12)', label: status };
//     }
//   };

//   const getActionElement = (request: any) => {
//     const status = request.status.toLowerCase();
//     const isPending = status === 'pending';
//     const available = !request.isBuyRequestSomeOne;

//     if (isPending && available) {
//       return (
//         <Button
//           size="small"
//           startIcon={<FaShoppingCart size={11} />}
//           onClick={() => handleBuy(request)}
//           sx={{
//             minWidth: 78,
//             fontSize: '0.68rem',
//             fontWeight: 700,
//             textTransform: 'none',
//             bgcolor: '#10b981',
//             color: 'white',
//             borderRadius: 1.5,
//             py: 0.6,
//             px: 1.2,
//             boxShadow: '0 2px 8px rgba(16,185,129,0.3)',
//             '&:hover': {
//               bgcolor: '#059669',
//               boxShadow: '0 4px 12px rgba(16,185,129,0.4)'
//             }
//           }}
//         >
//           Buy
//         </Button>
//       );
//     }

//     if (status === 'accepted') {
//       return (
//         <Chip
//           label="Sold"
//           size="small"
//           sx={{
//             bgcolor: 'rgba(139, 92, 246, 0.22)',
//             color: '#ddd6fe',
//             fontWeight: 700,
//             fontSize: '0.7rem',
//             height: 26,
//             border: '1px solid rgba(139, 92, 246, 0.4)'
//           }}
//         />
//       );
//     }

//     if (isPending && !available) {
//       return (
//         <Box display="flex" alignItems="center" gap={0.8} color="#fbbf24">
//           <FaClock size={13} />
//           <Typography fontSize="0.75rem" fontWeight={500}>In Process</Typography>
//         </Box>
//       );
//     }

//     return null;
//   };

//   return (
//     <Paper elevation={0} sx={{ background: palette.cardBg, border: palette.border, boxShadow: palette.cardShadow, borderRadius: 2, overflow: 'hidden' }}>
//       {/* Header */}
//       <Box sx={{ p: { xs: 1.5, sm: 2 }, borderBottom: palette.border, background: 'rgba(59, 130, 246, 0.05)' }}>
//         <Typography variant="h6" sx={{ fontWeight: 600, color: palette.text, fontSize: { xs: '0.85rem', sm: '1rem' } }}>
//           Unit Marketplace
//         </Typography>
//       </Box>

//       {/* Toggle */}
//       <Box sx={{ p: { xs: 1.5, sm: 2 }, borderBottom: palette.border }}>
//         <ToggleButtonGroup value={unitType} exclusive onChange={handleUnitTypeChange} fullWidth={isMobile}
//           sx={{
//             height: { xs: 44, sm: 56 },
//             bgcolor: 'rgba(255,255,255,0.04)',
//             borderRadius: 2.5,
//             p: { xs: 0.5, sm: 0.75 },
//             border: '1px solid rgba(255,255,255,0.06)',
//             '& .MuiToggleButton-root': {
//               border: 'none',
//               borderRadius: 2,
//               textTransform: 'none',
//               fontWeight: 600,
//               fontSize: { xs: '0.75rem', sm: '0.95rem' },
//               py: { xs: 1.2, sm: 1.8 },
//               color: palette.subText,
//               '&:hover': { bgcolor: 'rgba(255,255,255,0.08)', color: '#e2e8f0' },
//               '&.Mui-selected': {
//                 color: '#FFFFFF !important',
//                 fontWeight: 700,
//                 boxShadow: '0 0 0 2px rgba(255,255,255,0.15), 0 0 20px rgba(59, 130, 246, 0.3), inset 0 2px 8px rgba(255,255,255,0.12)',
//                 transform: 'translateY(-2px)'
//               }
//             }
//           }}
//         >
//           <ToggleButton value="incomeUnits"
//             sx={{
//               bgcolor: unitType === 'incomeUnits' ? 'linear-gradient(135deg, #3b82f6 0%, #0ea5e9 100%)' : 'transparent',
//               '&.Mui-selected': { bgcolor: 'linear-gradient(135deg, #3b82f6 0%, #0ea5e9 100%)' }
//             }}
//           >
//             <FaCoins style={{ marginRight: isMobile ? 6 : 10 }} size={isMobile ? 12 : 14} /> Income Units
//           </ToggleButton>
//           <ToggleButton value="growthUnits"
//             sx={{
//               bgcolor: unitType === 'growthUnits' ? 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)' : 'transparent',
//               '&.Mui-selected': { bgcolor: 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)' }
//             }}
//           >
//             <FaArrowUp style={{ marginRight: isMobile ? 6 : 10 }} size={isMobile ? 12 : 14} /> Growth Units
//           </ToggleButton>
//         </ToggleButtonGroup>
//       </Box>

//       {/* Search */}
//       <Box sx={{ p: { xs: 1.5, sm: 2 }, borderBottom: palette.border, bgcolor: '#0f1115' }}>
//         <TextField
//           fullWidth size="small" placeholder="Search seller..." value={search} onChange={(e) => setSearch(e.target.value)}
//           InputProps={{
//             startAdornment: <InputAdornment position="start"><FaSearch color="#60a5fa" size={isMobile ? 12 : 14} /></InputAdornment>
//           }}
//           sx={{
//             '& .MuiOutlinedInput-root': {
//               borderRadius: 1.5,
//               backgroundColor: '#1a1c20',
//               fontSize: { xs: '0.75rem', sm: '0.85rem' },
//               color: '#e5e7eb',
//               '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
//               '&:hover fieldset': { borderColor: 'rgba(96,165,250,0.6)' },
//               '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
//               '& input': { backgroundColor: '#1a1c20', color: '#e5e7eb' }
//             },
//             '& .MuiInputBase-input::placeholder': { color: 'rgba(255,255,255,0.4)', opacity: 1 }
//           }}
//         />
//       </Box>

//       {/* List */}
//       <Box sx={{ maxHeight: { xs: '380px', sm: '440px' }, overflowY: 'auto', p: { xs: 1.5, sm: 2 } }}>
//         {loading ? (
//           <Box textAlign="center" py={6}>
//             <CircularProgress size={36} sx={{ color: '#3b82f6' }} />
//             <Typography mt={2} color={palette.subText}>Loading offers...</Typography>
//           </Box>
//         ) : filtered.length === 0 ? (
//           <Box textAlign="center" py={6}>
//             <FaSearch size={42} color="rgba(255,255,255,0.1)" />
//             <Typography mt={2} color={palette.text} fontSize="1rem">No active offers</Typography>
//             <Typography color={palette.subText} fontSize="0.85rem">Check back later</Typography>
//           </Box>
//         ) : (
//           <List disablePadding>
//             {filtered.map((request: any) => {
//               const status = getStatusConfig(request.status);
//               const action = getActionElement(request);

//               return (
//                 <ListItem
//                   key={request.requestId}
//                   disablePadding
//                   sx={{
//                     mb: 1.5,
//                     borderRadius: 2,
//                     background: 'rgba(255,255,255,0.025)',
//                     border: '1px solid rgba(255,255,255,0.06)',
//                     overflow: 'hidden',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       borderColor: '#3b82f6',
//                       boxShadow: '0 6px 25px rgba(59, 130, 246, 0.25)',
//                       transform: 'translateY(-3px)'
//                     }
//                   }}
//                 >
//                   <Grid container alignItems="center" sx={{ p: { xs: 1.5, sm: 2 } }}>
//                     {/* Seller Info */}
//                     <Grid item xs={12} sm={4} md={3}>
//                       <Box display="flex" alignItems="center" gap={1.5}>
//                         <Box
//                           sx={{
//                             width: 40,
//                             height: 40,
//                             borderRadius: 2,
//                             background: unitType === 'incomeUnits'
//                               ? 'linear-gradient(135deg, #3b82f6, #0ea5e9)'
//                               : 'linear-gradient(135deg, #f97316, #fb923c)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             color: '#fff',
//                             flexShrink: 0
//                           }}
//                         >
//                           <FaUser size={16} />
//                         </Box>
//                         <Box minWidth={0}>
//                           <Typography noWrap sx={{ fontWeight: 600, color: palette.text, fontSize: { xs: '0.85rem', sm: '0.9rem' } }}>
//                             {request.sellerName}
//                           </Typography>
//                           <Typography noWrap sx={{ color: palette.subText, fontSize: { xs: '0.7rem', sm: '0.75rem' } }}>
//                             {request.sellerEmailId}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </Grid>

//                     {/* Stats */}
//                     <Grid item xs={4} sm={2} md={1.5}>
//                       <Typography sx={{ color: palette.subText, fontSize: '0.75rem' }}>Units</Typography>
//                       <Typography sx={{ fontWeight: 700, color: palette.text, fontSize: '0.9rem' }}>
//                         {parseFloat(request.sellUnits).toLocaleString()}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={4} sm={2} md={1.5}>
//                       <Typography sx={{ color: palette.subText, fontSize: '0.75rem' }}>Price</Typography>
//                       <Typography sx={{ fontWeight: 700, color: '#10b981', fontSize: '0.9rem' }}>
//                         {formatCurrency(request.unitPrice)}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={4} sm={2} md={1.5}>
//                       <Typography sx={{ color: palette.subText, fontSize: '0.75rem' }}>Charge</Typography>
//                       <Typography sx={{ fontWeight: 700, color: '#10b981', fontSize: '0.9rem' }}>
//                         {request.operationCharge}%
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={6} sm={2} md={2}>
//                       <Typography sx={{ color: palette.subText, fontSize: '0.75rem' }}>Total</Typography>
//                       <Typography sx={{ fontWeight: 700, color: '#34d399', fontSize: '0.9rem' }}>
//                         {formatCurrency(request.sellUnits * request.unitPrice)}
//                       </Typography>
//                     </Grid>

//                     {/* Status + Action (Right Aligned) */}
//                     <Grid item xs={6} sm={2} md={2} display="flex" justifyContent="flex-end" alignItems="center" gap={1.5}>
//                       <Chip label={status.label} size="small" sx={{ bgcolor: status.bg, color: status.color, fontWeight: 600, fontSize: '0.7rem', height: 26 }} />
//                       {action}
//                     </Grid>
//                   </Grid>
//                 </ListItem>
//               );
//             })}
//           </List>
//         )}
//       </Box>
//     </Paper>
//   );
// }

// src/components/fundManagement/mainDashboard/BuySellingUnitsSection.tsx
// src/components/fundManagement/mainDashboard/BuySellingUnitsSection.tsx

import React, { useEffect, useMemo, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  InputAdornment,
  List,
  ListItem,
  Paper,
  Snackbar,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useAppSelector } from 'app/hooks';
import axiosInstance from 'Services/APIService';
import {
  FaArrowUp,
  FaCheckCircle,
  FaClock,
  FaCoins,
  FaListAlt,
  FaSearch,
  FaShoppingCart,
  FaUser
} from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getBuySellingUnitsDashboard } from 'slices/fundManagementInvestment/simulationDashboardSlice';

const formatCurrency = (amount: number | string): string =>
  new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(Number(amount));

interface BuySellingUnitsSectionProps {
  onUnitSelect?: (unitType: 'income' | 'growth') => void;
}


const getUserDetails = () => {
  const loginInfo = localStorage.getItem('user-details');
  return loginInfo ? JSON.parse(loginInfo) : null;
};

const BuySellingUnitsSection: React.FC<BuySellingUnitsSectionProps> = ({ onUnitSelect }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const selectedProjectId = useAppSelector((s) => s.homeTilesServices.selectedProjectId);
  const buySellingData = useAppSelector((s) => s.simulationDashboard.buySellingUnitsDashboardData);
  const loading = useAppSelector((s) => s.simulationDashboard.buySellingUnitsDashboardLoading);

  const [search, setSearch] = useState('');
  const [unitType, setUnitType] = useState<'incomeUnits' | 'growthUnits'>('growthUnits');
  const [viewMode, setViewMode] = useState<'forSell' | 'sold'>('forSell');

  const [avatarUrls, setAvatarUrls] = useState<Record<string, string | null>>({});
  const [loadingAvatars, setLoadingAvatars] = useState<Set<string>>(new Set());

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'warning'
  });

  // Avatar loading
  useEffect(() => {
    const fetchAvatars = async () => {
      if (!buySellingData) return;

      const requests = Array.isArray(buySellingData)
        ? buySellingData.flatMap((d: any) => d.buySellingUnitRequests || [])
        : buySellingData.buySellingUnitRequests || [];

      const newUrls: Record<string, string | null> = { ...avatarUrls };

      for (const r of requests) {
        if (!r.sellerAvatar || newUrls[r.requestId] !== undefined) continue;

        setLoadingAvatars((s) => new Set(s).add(r.requestId));
        newUrls[r.requestId] = null;

        try {
          const res = await axiosInstance.get(
            `/avatar/get-avatar?path=${encodeURIComponent(r.sellerAvatar)}`,
            { responseType: 'blob' }
          );
          newUrls[r.requestId] = URL.createObjectURL(res.data);
        } catch {
          newUrls[r.requestId] = null;
        } finally {
          setLoadingAvatars((s) => {
            const ns = new Set(s);
            ns.delete(r.requestId);
            return ns;
          });
        }
      }
      setAvatarUrls(newUrls);
    };

    fetchAvatars();

    return () => {
      Object.values(avatarUrls).forEach((url) => url && URL.revokeObjectURL(url));
      setAvatarUrls({});
    };
  }, [buySellingData]);

    const investorEmail = useMemo(() => {
      const user = getUserDetails();
      return user?.email || '';
    }, []);

  // Fetch data
  useEffect(() => {
    if (selectedProjectId) {
      dispatch(
        getBuySellingUnitsDashboard({
          groupId: selectedProjectId,
          serviceId: 'fundManagementInvestment',
          unitType,
          isSoldList: viewMode === 'sold'
        } as any)
      );
    }
  }, [selectedProjectId, unitType, viewMode, dispatch]);

  const handleUnitTypeChange = (_: any, value: 'incomeUnits' | 'growthUnits' | null) => {
    if (value) {
      setUnitType(value);
      onUnitSelect?.(value === 'incomeUnits' ? 'income' : 'growth');
    }
  };

  const handleViewModeChange = (_: any, value: 'forSell' | 'sold' | null) => {
    if (value) setViewMode(value);
  };

 const handleBuy = (request: any) => {
   console.log('request', request.sellerEmailId, request.sellerEmailId === investorEmail);

   if (request.sellerEmailId?.toLowerCase() === investorEmail?.toLowerCase()) {
     setSnackbar({
       open: true,
       message: 'You cannot buy units your own.',
       severity: 'warning'
     });
     return;
   }

   navigate('/fundManagementInvestment/purchase-units', {
     state: { fromMarketplace: true, sellingRequest: request }
   });
 };



  const requests = Array.isArray(buySellingData)
    ? buySellingData.flatMap((d: any) => d.buySellingUnitRequests || [])
    : buySellingData?.buySellingUnitRequests || [];

  const filtered = requests.filter(
    (r: any) =>
      !search ||
      r.sellerName?.toLowerCase().includes(search.toLowerCase()) ||
      r.sellerEmailId?.toLowerCase().includes(search.toLowerCase())
  );

  const getStatusConfig = (status: string) => {
    const s = status.toLowerCase();
    if (s === 'pending') return { color: '#fbbf24', bg: 'rgba(251,146,60,0.15)', label: 'Pending' };
    if (s === 'accepted')
      return { color: '#8b5cf6', bg: 'rgba(139,92,246,0.15)', label: 'Accepted' };
    if (s === 'completed')
      return { color: '#34d399', bg: 'rgba(52,211,153,0.15)', label: 'Completed' };
    if (s === 'rejected')
      return { color: '#f87171', bg: 'rgba(248,113,113,0.15)', label: 'Rejected' };
    return { color: '#94a3b8', bg: 'rgba(148,163,184,0.12)', label: status };
  };

  const getActionElement = (r: any) => {
    if (viewMode === 'sold') {
      return (
        <Chip
          icon={<FaCheckCircle size={12} />}
          label="Sold"
          size="small"
          sx={{ bgcolor: 'rgba(34,197,94,0.22)', color: '#86efac', fontWeight: 700 }}
        />
      );
    }
    const pending = r.status.toLowerCase() === 'pending';
    const available = !r.isBuyRequestSomeOne;
    if (pending && available) {
      return (
        <Button
          size="small"
          startIcon={<FaShoppingCart size={11} />}
          onClick={() => handleBuy(r)}
          sx={{
            bgcolor: '#10b981',
            color: '#fff',
            fontWeight: 700,
            fontSize: '0.68rem',
            '&:hover': { bgcolor: '#059669' }
          }}
        >
          Buy
        </Button>
      );
    }
    if (r.status.toLowerCase() === 'accepted') {
      return (
        <Chip
          label="Sold"
          size="small"
          sx={{ bgcolor: 'rgba(139,92,246,0.22)', color: '#ddd6fe', fontWeight: 700 }}
        />
      );
    }
    if (pending && !available) {
      return (
        <Box display="flex" alignItems="center" gap={0.8} color="#fbbf24">
          <FaClock size={13} />
          <Typography fontSize="0.75rem">In Process</Typography>
        </Box>
      );
    }
    return null;
  };

  return (
    <Paper
      elevation={0}
      sx={{
        bgcolor: 'rgba(36,37,44,0.97)',
        border: '1px solid rgba(255,255,255,0.05)',
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: '0 8px 40px rgba(0,0,0,0.8)'
      }}
    >
      {/* Header */}
      <Box
        sx={{
          p: { xs: 1.5, sm: 2 },
          borderBottom: '1px solid rgba(255,255,255,0.05)',
          bgcolor: 'rgba(59,130,246,0.05)'
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, color: '#EEF1F6', fontSize: { xs: '0.85rem', sm: '1rem' } }}
        >
          Unit Marketplace {viewMode === 'sold' ? '— Sold History' : '— Active Listings'}
        </Typography>
      </Box>

      {/* === BOTH TOGGLES — CRYSTAL CLEAR SELECTED STATE === */}
      <Box
        sx={{
          p: { xs: 1.5, sm: 2 },
          borderBottom: '1px solid rgba(255,255,255,0.05)',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          bgcolor: '#0f1115',
          color: '#A6ABBF'
        }}
      >
        {/* Unit Type Toggle */}
        <ToggleButtonGroup
          value={unitType}
          exclusive
          onChange={handleUnitTypeChange}
          fullWidth={isMobile}
          sx={{
            height: { xs: 52, sm: 58 },
            bgcolor: '#181b20',
            borderRadius: 3,
            border: '1px solid rgba(255,255,255,0.08)',
            overflow: 'hidden',
            boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.3)',
            color: '#A6ABBF'
          }}
        >
          {(['incomeUnits', 'growthUnits'] as const).map((type) => (
            <ToggleButton
              key={type}
              value={type}
              sx={{
                border: 'none',
                borderRadius: 2.5,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: { xs: '0.84rem', sm: '0.96rem' },
                py: 2,
                // color: unitType === type ? '#FFFFFF !important' : '#94a3b8',
                color: '#A6ABBF',
                bgcolor:
                  unitType === type
                    ? type === 'incomeUnits'
                      ? 'linear-gradient(135deg, #3b82f6 0%, #0ea5e9 100%)'
                      : 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)'
                    : 'transparent',
                position: 'relative',
                transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  color: '#FFFFFF',
                  bgcolor: unitType === type ? undefined : 'rgba(255,255,255,0.08)'
                },
                '&.Mui-selected': {
                  color: '#FFFFFF !important',
                  fontWeight: 700,
                  zIndex: 2,
                  // transform: 'translateY(-4px)',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.6)',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 2.5,
                    padding: '2px',
                    background:
                      unitType === type
                        ? 'linear-gradient(135deg, #60a5fa, #3b82f6)'
                        : 'linear-gradient(135deg, #fb923c, #f97316)',
                    mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                    maskComposite: 'exclude',
                    opacity: 0.7,
                    pointerEvents: 'none'
                  }
                }
              }}
            >
              {type === 'incomeUnits' ? (
                <>
                  <FaCoins size={isMobile ? 14 : 16} style={{ marginRight: 10 }} />
                  Income Units
                </>
              ) : (
                <>
                  <FaArrowUp size={isMobile ? 14 : 16} style={{ marginRight: 10 }} />
                  Growth Units
                </>
              )}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>

        {/* View Mode Toggle */}
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={handleViewModeChange}
          fullWidth={isMobile}
          sx={{
            height: { xs: 52, sm: 58 },
            bgcolor: '#181b20',
            borderRadius: 3,
            border: '1px solid rgba(255,255,255,0.08)',
            overflow: 'hidden',
            boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.3)'
          }}
        >
          {(['forSell', 'sold'] as const).map((mode) => (
            <ToggleButton
              key={mode}
              value={mode}
              sx={{
                border: 'none',
                borderRadius: 2.5,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: { xs: '0.84rem', sm: '0.96rem' },
                py: 2,
                color: viewMode === mode ? '#FFFFFF !important' : '#94a3b8',
                bgcolor:
                  viewMode === mode
                    ? mode === 'forSell'
                      ? 'linear-gradient(135deg, #10b981 0%, #34d399 100%)'
                      : 'linear-gradient(135deg, #8b5cf6 0%, #c4b5fd 100%)'
                    : 'transparent',
                position: 'relative',
                transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  color: '#FFFFFF',
                  bgcolor: viewMode === mode ? undefined : 'rgba(255,255,255,0.08)'
                },
                '&.Mui-selected': {
                  color: '#FFFFFF !important',
                  fontWeight: 700,
                  zIndex: 2,
                  // transform: 'translateY(-4px)',
                  boxShadow: '0 8px 25px rgba(0,0,0,0.6)',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 2.5,
                    padding: '2px',
                    background:
                      viewMode === mode
                        ? mode === 'forSell'
                          ? 'linear-gradient(135deg, #34d399, #10b981)'
                          : 'linear-gradient(135deg, #c4b5fd, #8b5cf6)'
                        : 'transparent',
                    mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                    maskComposite: 'exclude',
                    opacity: 0.8,
                    pointerEvents: 'none'
                  }
                }
              }}
            >
              {mode === 'forSell' ? (
                <>
                  <FaListAlt size={isMobile ? 14 : 16} style={{ marginRight: 10 }} />
                  For Sell
                </>
              ) : (
                <>
                  <FaCheckCircle size={isMobile ? 14 : 16} style={{ marginRight: 10 }} />
                  Sold
                </>
              )}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>

      {/* Search Field */}
      <Box
        sx={{
          p: { xs: 1.5, sm: 2 },
          borderBottom: '1px solid rgba(255,255,255,0.07)',
          bgcolor: '#0f1115'
        }}
      >
        <TextField
          fullWidth
          size="small"
          placeholder="Search seller..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FaSearch color="#60a5fa" size={isMobile ? 12 : 14} />
              </InputAdornment>
            )
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 1.8,
              backgroundColor: '#1a1c20',
              color: '#e5e7eb',
              fontSize: { xs: '0.75rem', sm: '0.85rem' },
              '& fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
              '&:hover fieldset': { borderColor: '#3b82f6' },
              '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
              '& input': { backgroundColor: '#1a1c20', color: '#fff' }
            },
            '& .MuiInputBase-input::placeholder': { color: 'rgba(255,255,255,0.4)', opacity: 1 }
          }}
        />
      </Box>

      {/* List */}
      <Box
        sx={{ maxHeight: { xs: '380px', sm: '440px' }, overflowY: 'auto', p: { xs: 1.5, sm: 2 } }}
      >
        {loading ? (
          <Box textAlign="center" py={6}>
            <CircularProgress size={36} sx={{ color: '#3b82f6' }} />
            <Typography mt={2} color="#A6ABBF">
              Loading...
            </Typography>
          </Box>
        ) : filtered.length === 0 ? (
          <Box textAlign="center" py={6}>
            <Typography color="#EEF1F6" fontSize="1rem">
              {viewMode === 'sold' ? 'No sold units yet' : 'No active offers'}
            </Typography>
          </Box>
        ) : (
          <List disablePadding>
            {filtered.map((r: any) => {
              const st = getStatusConfig(r.status);
              const avatar = avatarUrls[r.requestId];
              const loadingAvatar = loadingAvatars.has(r.requestId);

              return (
                <ListItem
                  key={r.requestId}
                  disablePadding
                  sx={{
                    mb: 1.5,
                    borderRadius: 2,
                    bgcolor: 'rgba(255,255,255,0.025)',
                    border: '1px solid rgba(255,255,255,0.06)',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: '#3b82f6',
                      boxShadow: '0 6px 25px rgba(59,130,246,0.25)',
                      transform: 'translateY(-3px)'
                    }
                  }}
                >
                  <Grid container alignItems="center" sx={{ p: { xs: 1.5, sm: 2 } }}>
                    <Grid item xs={12} sm={4} md={3}>
                      <Box display="flex" alignItems="center" gap={1.5}>
                        <Box
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: 2,
                            overflow: 'hidden',
                            flexShrink: 0,
                            border: '2px solid rgba(255,255,255,0.12)',
                            bgcolor: avatar ? 'transparent' : 'rgba(255,255,255,0.05)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {loadingAvatar ? (
                            <CircularProgress size={20} sx={{ color: '#60a5fa' }} />
                          ) : avatar ? (
                            <img
                              src={avatar}
                              alt={r.sellerName}
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : (
                            <FaUser size={18} color="#94a3b8" />
                          )}
                        </Box>
                        <Box minWidth={0}>
                          <Typography
                            noWrap
                            sx={{
                              fontWeight: 600,
                              color: '#EEF1F6',
                              fontSize: { xs: '0.85rem', sm: '0.9rem' }
                            }}
                          >
                            {r.sellerName}
                          </Typography>
                          <Typography
                            noWrap
                            sx={{ color: '#A6ABBF', fontSize: { xs: '0.7rem', sm: '0.75rem' } }}
                          >
                            {r.sellerEmailId}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={4} sm={2} md={1.5}>
                      <Typography sx={{ color: '#A6ABBF', fontSize: '0.75rem' }}>Units</Typography>
                      <Typography sx={{ fontWeight: 700, color: '#EEF1F6', fontSize: '0.9rem' }}>
                        {parseFloat(r.sellUnits).toLocaleString()}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} sm={2} md={1.5}>
                      <Typography sx={{ color: '#A6ABBF', fontSize: '0.75rem' }}>Price</Typography>
                      <Typography sx={{ fontWeight: 700, color: '#10b981', fontSize: '0.9rem' }}>
                        {formatCurrency(r.unitPrice)}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} sm={2} md={1.5}>
                      <Typography sx={{ color: '#A6ABBF', fontSize: '0.75rem' }}>Charge</Typography>
                      <Typography sx={{ fontWeight: 700, color: '#10b981', fontSize: '0.9rem' }}>
                        ${r.operationCharge}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={2} md={2}>
                      <Typography sx={{ color: '#A6ABBF', fontSize: '0.75rem' }}>Total</Typography>
                      <Typography sx={{ fontWeight: 700, color: '#34d399', fontSize: '0.9rem' }}>
                        {formatCurrency(r.sellUnits * r.unitPrice)}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={6}
                      sm={2}
                      md={2}
                      display="flex"
                      justifyContent="flex-end"
                      alignItems="center"
                      gap={1.5}
                    >
                      <Chip
                        label={st.label}
                        size="small"
                        sx={{
                          bgcolor: st.bg,
                          color: st.color,
                          fontWeight: 600,
                          fontSize: '0.7rem',
                          height: 26
                        }}
                      />
                      {getActionElement(r)}
                    </Grid>
                  </Grid>
                </ListItem>
              );
            })}
          </List>
        )}
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity as any}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default BuySellingUnitsSection;
